import React, { useState } from 'react';
import { TabPanel, TabView } from 'primereact/tabview';
import JetinnoDirectTelemetry from './JetinnoDirectTelemetry';
import JetinnoSaasSnapshot from './JetinnoSaasSnapshot';
import './JetinnoDashboard.scss';

const JetinnoDashboard = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    return (
        <div className="jetinno-dashboard">
            <TabView activeIndex={activeIndex} onTabChange={(event) => setActiveIndex(event.index)}>
                <TabPanel header="Telemetría directa">
                    <JetinnoDirectTelemetry />
                </TabPanel>
                <TabPanel header="Snapshot Jetinno SaaS">
                    <JetinnoSaasSnapshot />
                </TabPanel>
            </TabView>
        </div>
    );
};

export default JetinnoDashboard;
